import React, { useState } from "react";
import { supabase } from "../pages/supabaseClient";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [forgotMode, setForgotMode] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) {
      setMessage("Login failed: " + error.message);
    } else if (data?.user) {
      onLogin(data.user);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage("Please enter your email above first.");
      return;
    }
    const { error } = await supabase.auth.resetPasswordForEmail(email);
    if (error) {
      setMessage("Error: " + error.message);
    } else {
      setMessage("Password reset email sent! Check your inbox.");
    }
  };

  return (
    <div style={{
      display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", background: "#f6f8fb"
    }}>
      <form
        className="login-form"
        onSubmit={forgotMode ? handleForgotPassword : handleSubmit}
        style={{
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 2px 12px #0001",
          padding: 36,
          minWidth: 320,
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <h2 style={{ marginBottom: 24 }}>
          <span role="img" aria-label="key">🔑</span> Staff Login
        </h2>
        <input
          type="email"
          placeholder="Email"
          value={email}
          autoComplete="username"
          onChange={e => setEmail(e.target.value)}
          required
        />
        {!forgotMode && (
          <input
            type="password"
            placeholder="Password"
            value={password}
            autoComplete="current-password"
            onChange={e => setPassword(e.target.value)}
            required
          />
        )}
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "12px 0",
            background: "#2979ff",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            fontWeight: 600,
            fontSize: 16,
            cursor: "pointer",
            marginBottom: 16,
            boxShadow: "0 2px 6px #2979ff22"
          }}
        >
          {forgotMode ? "Send Reset Email" : "Login"}
        </button>
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            setForgotMode(!forgotMode);
            setMessage("");
          }}
          style={{ color: "#2979ff", fontWeight: 500, fontSize: 15, textDecoration: "none" }}
        >
          {forgotMode ? "Back to Login" : "Forgot Password?"}
        </a>
        {message && <div style={{ color: message.startsWith("Error") ? "crimson" : "green", marginTop: 12 }}>{message}</div>}
      </form>
    </div>
  );
}